module.exports = __webpack_public_path__ + "img/gameplay1.51f33e37.png";